<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template slot-scope="dialogProps">

      <VcModalContainer :showDialog="true"
                        :showCloseButton="true"
                        size="xl"
                        :useOffset="false"
                        :showFooterDivider="false"
                        @onCloseButtonClicked="handleClose">
        <template #content>
          <MarketingUpgradePage mode="dialog"
                                :asset="asset"
                                @close="handleClose"/>
        </template>
      </VcModalContainer>

    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog} from "@/modules/common/components";
import MarketingUpgradePage from "./MarketingUpgradePage";

export default {
  name: "MarketingUpgradeDialog",
  components: {FullscreenFrontageDialog, MarketingUpgradePage},
  props: {
    asset: {
      type: String,
      default: 'templates'
    }
  },
  methods: {
    handleClose() {
      this.$refs.frontageDialog.handleClose();
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
